/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Tag, Typography, Row, Col, List, Space, Avatar, Tooltip } from "antd";
// import { formatCurrency } from "../../servos/numberHelpers";
import ProfessionalSelectList from "./ProfessionalSelectList";

import { isDesktop, isMobile } from "react-device-detect";
import { ClockCircleTwoTone, CreditCardTwoTone } from "@ant-design/icons";

// const responsiveGutter = { xs: 8, sm: 16, md: 16, lg: 16 };

function RenderReasonList({
	reasons,
	availabilityRequests,
	toggleItem,
	themeColor,
	practitionerId,
	multiSelect,
}) {
	const [visible, setVisible] = React.useState(false);

	return (
		<>
			<List
				itemLayout="vertical"
				dataSource={reasons}
				renderItem={(item) => (
					<List.Item key={item?.id} onClick={() => setVisible(!visible)}>
						<>
							<Row justify="space-between" gutter={[32, 8]} align="middle">
								<Col md={18} xs={24}>
									<Space>
										{item?.coverPhoto?.url && (
											<>
												<Avatar
													size={32}
													shape="square"
													src={item?.coverPhoto?.url}
												/>
											</>
										)}
										<Space direction="vertical" size={0}>
											<Space direction="vertical" size="0">
												<Typography.Text
													strong
													style={{ margin: 0, padding: 0 }}
												>
													{item.name}
												</Typography.Text>
											</Space>

											<Space size="large" wrap>
												{item.minutes > 0 && (
													<Tooltip title="Estimated duration">
														<ClockCircleTwoTone
															twoToneColor={themeColor ? themeColor : "#ddd"}
														/>{" "}
														{item.minutes} mins
													</Tooltip>
												)}

												{item?.showTotalCost && item.price > 0 && (
													<Tooltip title="Estimated cost">
														<CreditCardTwoTone
															twoToneColor={themeColor ? themeColor : "#ddd"}
														/>{" "}
														${item.price}
													</Tooltip>
												)}
												{item?.requireDeposit && item?.onlineBookingsPrice > 0.0 && (
													<>
														<Tooltip title="Deposit required">
															<Space>
																Deposit:
																<Tag
																	style={{
																		background: themeColor ? themeColor : "#bbb",
																	}}
																>
																	${item.onlineBookingsPrice}
																</Tag>
															</Space>
														</Tooltip>
													</>
												)}
											</Space>
										</Space>
									</Space>

									{item.description && (
										<div
											style={{
												maxHeight: "350px",
												overflow: "auto",
												marginTop: 16,
											}}
										>
											<Typography.Text
												type="secondary"
												style={{ padding: 0, margin: 0 }}
											>
												{item.description}
											</Typography.Text>
										</div>
									)}
								</Col>
								{isDesktop && (
									<Col flex="200px">
										{!multiSelect && (
											<ProfessionalSelectList
												themeColor={themeColor}
												toggleItem={toggleItem}
												item={item}
												practitionerId={practitionerId}
												appointmentReasonId={item.id}
												availabilityRequests={availabilityRequests}
											/>
										)}
									</Col>
								)}

								{isMobile && (
									<Col xs={24}>
										{!multiSelect && (
											<ProfessionalSelectList
												themeColor={themeColor}
												toggleItem={toggleItem}
												item={item}
												practitionerId={practitionerId}
												appointmentReasonId={item.id}
												availabilityRequests={availabilityRequests}
											/>
										)}
									</Col>
								)}
							</Row>
						</>
					</List.Item>
				)}
			/>
		</>
	);
}
export default RenderReasonList;
